import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { user } from 'services';
import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';

export const BookingGrid = (props) => {
  const { count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const [showQr, setShowQr] = useState(false);
  const [row, setRow] = useState({});
  // const rightView = user.haveRight('stays.view');

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  /**
   * go to park session card
   * @param {*} row
   */
  const showParkingCardAction = (row) => {
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  /**
   * go to subscription with filter
   * @param {*} row
   */
  const showSubscriptionAction = (row) => {
    history.push(path('subscription'), {
      filter: {
        mean_id: row.mean_id,
      },
    });
  };

  /**
   * toggle qr window
   */
  const showQrWindow = () => {
    setShowQr((val) => !val);
  };

  // actions
  const actions = [];
  actions.push({ title: t('buttons.Перейти в карточку парковки'), action: showParkingCardAction, isVisible: (row) => !!row.stay_id });

  // actions.push({ title: t('buttons.Перейти в абонементы'), action: showSubscriptionAction, isVisible: (row) => row.mean_type === 'subscription' && !!row.result });

  // actions.push({
  //   title: t('buttons.QR чека'),
  //   action: (row) => {
  //     setRow(row);
  //     showQrWindow();
  //   },
  //   isVisible: (row) => !!row.data?.check_qrcode,
  // });

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('booking', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt theme={theme} title={t('sections.Бронирование')} rows={{ count, items }} actions={actions} className={className} refresh={props.refresh} {...restTableParams} fields={fields} />

      {showQr && <Qr close={showQrWindow} id={row.id} />}
    </GridBox>
  );
};
